"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.register = register;

require("core-js/modules/es6.object.freeze");

var _cssClasses = _interopRequireDefault(require("../../helpers/cssClasses"));

var _utils = require("../../helpers/utils");

var _ebookUtils = require("../../components/ebook-utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Template: Register
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Register template.
 *
 * @namespace register
 */

/**
 * DOM selectors.
 */


var selectors = {
  customerLoginForm: '[js-password-form="customerLoginForm"]'
};

function register() {
  /**
   * DOM Node selectors.
   */
  var nodeSelectors = {
    customerLoginForm: document.querySelector(selectors.customerLoginForm)
  };
  /**
   * Initialise login form.
   */

  function init() {
    checkFreeReadsCookie();
  }
  /**
   * If the user navigates from Free Reads -> Login/Register, a storage item
   * is set. We will now set a storage item for a login/resiger attempt
   * to reference on the account page later.
   */


  function checkFreeReadsCookie() {
    var registerForm = nodeSelectors.customerLoginForm.querySelector('#customer_login');
    var passwordInput = nodeSelectors.customerLoginForm.querySelector('#CustomerPassword');
    var emailInput = nodeSelectors.customerLoginForm.querySelector('#CustomerEmail');
    (0, _utils.on)('submit', registerForm, function (event) {
      event.preventDefault();

      if (window.sessionStorage.getItem('mb_free_reads') !== null) {
        window.sessionStorage.setItem('mb_submit_attempt', 'register');
      }

      registerForm.submit();

      if (window.localStorage.getItem('mb-customer-access-token') === null) {
        (0, _ebookUtils.getCustomerAccessToken)(emailInput.value, passwordInput.value);
      }
    });
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
}

register().init();